import React from 'react';
import { Table, Badge, Spinner } from 'react-bootstrap';

interface NominationHistoryProps {
    nominations: any[];
    isLoading: boolean;
}

export const EmployeeNominationHistory = ({ nominations, isLoading }: NominationHistoryProps) => {
    if (isLoading) {
        return <div className="text-center p-3"><Spinner animation="border" /></div>;
    }
    if (!nominations || nominations.length === 0) {
        return <p className="text-center text-muted">No past nomination history found for this employee.</p>;
    }

    return (
        <div className="employee-nomination-history">
            <Table striped bordered hover responsive size="sm">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Award</th>
                        <th>Nominated By</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {nominations.map((nom) => {
                        let statusVariant = 'secondary';
                        if (nom.status === 'Approved') statusVariant = 'success';
                        if (nom.status === 'Rejected') statusVariant = 'danger';
                        if (nom.status === 'Pending') statusVariant = 'warning';

                        return (
                            <tr key={nom._id}>
                                <td>{new Date(nom.createdAt).toLocaleDateString()}</td>
                                <td>{nom.awardRef?.awardCategory || 'N/A'}</td>
                                <td>{`${nom.nominatedByRef?.candidateName || ''} ${nom.nominatedByRef?.lastname || ''}`}</td>
                                <td>
                                    <Badge bg={statusVariant}>{nom.status}</Badge>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </div>
    );
};